export default __webpack_public_path__ + "static/media/spinner.8401b3e6.gif";